import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-medicine-convert",
  "use": "icon-medicine-convert-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-medicine-convert\">\n  <!-- Capsule part 1 -->\n  <path d=\"M426.666667 213.333333H256c-70.613333 0-128 57.386667-128 128v128c0 70.613333 57.386667 128 128 128h170.666667V213.333333z\" fill=\"currentColor\" opacity=\"0.6\" />\n  <!-- Capsule part 2 -->\n  <path d=\"M597.333333 213.333333h170.666667c70.613333 0 128 57.386667 128 128v128c0 70.613333-57.386667 128-128 128H597.333333V213.333333z\" fill=\"currentColor\" />\n  <!-- Exchange arrows bottom -->\n  <path d=\"M768 725.333333l-128-128v85.333334H384v85.333333h256v85.333333l128-128zM256 725.333333l128 128v-85.333333h256v-85.333334H384v-85.333333l-128 128z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/medicine-convert.svg
// module id = joye
// module chunks = 72